<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Categories</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <new-category v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <categories-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import CategoriesTable from '@/components/inventory/master/category/index'
import NewCategory from '@/components/inventory/master/category/new'

export default {
  components: {
    CategoriesTable,
    NewCategory,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getCategories()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getCategories: function() {
      this.loading = true
      this.$http.get('/api/inventory/category', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getCategories()
    },
    handleUpdateTable: function() {
      this.getCategories()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getCategories()
    },
    onChange(current) {
      this.current = current
      this.getCategories()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
